/* DV-CHECKOUT-QTY-GUARD 2026-08-18
 * Sorun: Sepet formunda ozel kesim satirlarinin adet inputu gizli/eksik oldugu icin
 * name="updates[]" POZISYONEL eslesiyor ve "Odemeye gec" submit'i kesim satirinin
 * miktarini (orn. 180 birim = 5.400 TL) 1'e dusurup fiyati ~30 TL'ye cokertiyordu.
 * Cozum: checkout submit'inde updates[] inputlarini gecici devre disi birak.
 * Checkout POST'unun miktar guncellemesi tasimasi gerekmiyor; miktar degisiklikleri
 * temanin AJAX akisi (cart/change) ile zaten sunucuya islenmis durumda.
 */
(function () {
  'use strict';
  function disableUpdates(form) {
    if (!form) return;
    var action = (form.getAttribute('action') || '');
    if (action.indexOf('/cart') === -1) return;
    var inputs = form.querySelectorAll('input[name^="updates"]');
    if (!inputs.length) return;
    var disabled = [];
    inputs.forEach(function (i) { if (!i.disabled) { i.disabled = true; disabled.push(i); } });
    setTimeout(function () { disabled.forEach(function (i) { i.disabled = false; }); }, 5000);
  }
  function isCheckoutSubmitter(el) {
    return !!(el && el.getAttribute && el.getAttribute('name') === 'checkout');
  }
  document.addEventListener('submit', function (e) {
    if (e.submitter && isCheckoutSubmitter(e.submitter)) disableUpdates(e.target);
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn) return;
    disableUpdates(btn.form || btn.closest('form'));
  }, true);
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form[action*="/cart"] input[name^="updates"][disabled]').forEach(function (i) { i.disabled = false; });
  });
})();
